import { Store } from '@ngrx/store';
import { AuthActions } from '../store/auth/auth.actions';
import { DeviceTypeUtils } from '../../shared/utils/device-type-utils';
import { inject } from '@angular/core';
import { AUTHENTICATION_METHOD, MAINTENANCE_PERIOD } from '../constants/constants';
import { StringUtils } from '../../shared/utils/string.utils';
import { SessionStorageUtils } from '../../shared/utils/session-storage.utils';
import { TokenService } from './token.service';
import { DevToolsDetectorService } from './dev-tools-detector.service';
import { ServiceWorkerUpdateService } from './service-worker-update.service';
import { DateUtils } from '../../shared/utils/date.utils';

export const initializeApp = () => {
  const store = inject(Store);
  const tokenService = inject(TokenService);

  // Service worker update service
  inject(ServiceWorkerUpdateService).init();

  // Dev tools detector
  inject(DevToolsDetectorService).setupDevToolsDetector();

  // Streaming setup init
  // inject(WebClientService).init();

  // Maintenance Mode Logic
  if (
    DateUtils.new().isAfter(DateUtils.new(MAINTENANCE_PERIOD.start)) &&
    DateUtils.new().isBefore(DateUtils.new(MAINTENANCE_PERIOD.end))
  ) {
    store.dispatch(AuthActions.setMaintenanceMode());
    return;
  }

  const loginAsToken = new URL(window.location.href).searchParams.get('login-as');
  if (loginAsToken) {
    const [customerId, username, password] = window.atob(loginAsToken).split('|');
    if (customerId && username && password) {
      store.dispatch(
        AuthActions.authenticate({
          customerId: +customerId,
          username,
          password,
        })
      );
      store.dispatch(AuthActions.setLoggedInAs());
    }
  } else if (tokenService.getAuthTokenByKey('idToken')) {
    // store.dispatch(AuthActions.authenticateSuccess({accessToken: SessionStorageUtils.get(GlobalConstants.AuthKey)}))
    //@TODO: Rehydrate the LS and MP auth responses from localstorage or IDB to avoid calling authenticate again
    store.dispatch(
      AuthActions.authenticateLSMP({ token: tokenService.getAuthTokenByKey('idToken') })
    );
  } else {
    const identityServerToken = new URL(window.location.href).searchParams.get('it');
    if (identityServerToken) {
      try {
        const parsedToken = StringUtils.parseJwt(identityServerToken);
        // When user is redirected from clever or classlink then user first goes to account.mindplay.com and then redirected to studio
        // and the identity token in the url will contain authenticationMethod which will be used to auto close the tab on logout
        SessionStorageUtils.save(AUTHENTICATION_METHOD, parsedToken[AUTHENTICATION_METHOD]);

        // If the app is opened in in-app webview like classlink ios app then store the credentials and auth method to
        if (
          parsedToken[AUTHENTICATION_METHOD] === 'classLink' &&
          DeviceTypeUtils.isiPadInAppWebView()
        ) {
          window.localStorage.setItem(AUTHENTICATION_METHOD, parsedToken[AUTHENTICATION_METHOD]);
          window.localStorage.setItem(
            'c',
            window.btoa(
              `${parsedToken['customerId']}|${parsedToken['username']}|${parsedToken['password']}`
            )
          );
        }
        if (parsedToken['customerId'] && parsedToken['username'] && parsedToken['password']) {
          store.dispatch(
            AuthActions.authenticate({
              customerId: parsedToken['customerId'],
              username: parsedToken['username'],
              password: parsedToken['password'],
            })
          );
        } else {
          store.dispatch(AuthActions.authenticateLSMP({ token: identityServerToken }));
        }
      } catch (e) {
        console.error(e);
      }
    }
  }
};
